import { render, staticRenderFns } from "./TemplatePadding.vue?vue&type=template&id=7642128e"
import script from "./TemplatePadding.vue?vue&type=script&lang=js"
export * from "./TemplatePadding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports